module.exports = __webpack_public_path__ + "static/media/VIP_Purple@3x.20dbc7d4.png";